export default "__VITE_ASSET__DtaTxuMd__"